import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./plugins/langs/i18n/index";
import "xe-utils";
import VXETable from "vxe-table";
import axios from "axios";
import moment from "moment";
import "./directives/index"; //自定义指令引入

import "moment/locale/zh-cn";
moment.locale("zh-cn");

import Antd from "ant-design-vue"; // 导入antdv 组件库
import viewer from "v-viewer";
import lazyload from "vue-lazyload"; //图片懒加载
import { message, Modal } from "ant-design-vue";

import "normalize.css/normalize.css"; //重置浏览器样式
import "./assets/styles/common/antd.less"; // 初始化 antdv 组件库样式
import "@styles/common/theme.css"; //主题配置
import "@assets/fonts/iconfont.css"; //字体图标

import "./views/bi/assets/appfonts/iconfont.css"; //轻应用中心字体图标
import "./views/oneTablePlatform/assets/onTablefonts/iconfont.css"; //一表通字体图标
import "./views/oneTablePlatform/assets/styles/oneTableIcon.scss";
import "./views/workflow/assets/fonts/rbdIcon/iconfont.css"; // 表单引擎字体图标
import "./views/mobileLayout/assets/iconfont/iconfont.css"; // 小程序后台管理字体图标

import "@assets/icons/icon.css"; //精灵图
import "vxe-table/lib/style.css"; //表格基础样式
import "@styles/common/base.css"; //基础样式
import "viewerjs/dist/viewer.css";
import "./assets/styles/common/base.scss";

//引入 vue-awesome-swiper 样式
import "swiper/css/swiper.css";
//自定义svg组件
import "./components/common/rbdSvgIcon/index";
import _ from "lodash";
import VueAwesomeSwiper from "vue-awesome-swiper";
//引入 vue-awesome-swiper 样式
import "swiper/css/swiper.css";
import Base64 from "./utils/base64";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$message = message;
Vue.prototype.$modal = Modal;
Vue.prototype.$Base64 = Base64;
Vue.prototype.$message.config({
  top: "120px",
});
Vue.prototype._ = _;

Vue.use(Antd).use(viewer);
Vue.use(lazyload, {
  loading: require("../src/assets/images/common/lazy-loading.svg"), //图片加载未完成的时候显示的图片
  error: require("../src/assets/images/common/lazy-error.svg"), //类型string.图片加载失败后的显示的失败图片路径.
});
//处理ResizeObserver loop limit exceeded报错
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};

VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => i18n.t(key, args),
});
Vue.use(VXETable).use(VueAwesomeSwiper);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
